import React, {useRef} from 'react'
import PropTypes from 'prop-types'
import { NestedFieldSet, FormGroupInput } from 'components/formElements'
import { minScore, maxScore, stepScore } from 'util/library'
import {getScoreErrorMessage} from "util/validations"

const School = ({ handleChange, tenthScore, twelvethScore }) => {

    const tenthRef = useRef(null)
    const twelvethRef = useRef(null)

    return (
        <NestedFieldSet legendText='School'>
            <FormGroupInput
                type='number'
                min={minScore}
                max={maxScore}
                step={stepScore}
                id='tenthScore'
                name='tenthScore'
                value={tenthScore}
                onChange={handleChange}
                label='10th Score(%)'
                //placeholder='10th Score(%)'
                errorMessage={getScoreErrorMessage(tenthRef, tenthScore, true)}
                inputRef={tenthRef}
                required
            />
            <FormGroupInput
                type='number'
                min={minScore}
                max={maxScore}
                step={stepScore}
                id='twelvethScore'
                name='twelvethScore'
                value={twelvethScore}
                onChange={handleChange}
                label='12th Score(%)'
                //placeholder='12th Score(%)'
                errorMessage={getScoreErrorMessage(twelvethRef, twelvethScore, true)}
                inputRef={twelvethRef}
                required
            />
        </NestedFieldSet>
    )
}

School.propTypes = {
    handleChange: PropTypes.func.isRequired,
    tenthScore: PropTypes.string.isRequired,
    twelvethScore: PropTypes.string.isRequired,
}

export { School }
